import Snappy from '../libs/snappy/snappy';

import '../styles/eduhub-main.scss';

import objectFitVideos from 'object-fit-videos';

objectFitVideos();

window.$ = window.jQuery = require('jquery');

require('../components/edu-filters/scripts/edu-filters');
require('../components/edu-feedback/scripts/edu-feedback');
require('../components/edu-intro-tour/scripts/edu-intro-tour');
require('../components/edu-sticky/scripts/edu-sticky');
require('../components/edu-post-login-drd/scripts/edu-post-login-drd');
require('../components/edu-profile-privacy-toggler/scripts/edu-profile-privacy-toggler');
require('../components/edu-course-loader/scripts/edu-course-loader');
require('../components/edu-unsaved-data-observer/scripts/edu-unsaved-data-observer');
require('../components/revealEffect/scripts/revealEffect');
require('../components/copy-to-clipboard/scripts/copy-to-clipboard');
require('../components/scroll-progress/scripts/scroll-progress');
require('../components/session-hero/scripts/session-hero');
require('../components/grid-placeholder/scripts/grid-placeholder');
require('../components/playlist-nav/scripts/playlist-nav');
require('../components/modal-video/scripts/modal-video');
require('../components/comments/scripts/comments');
require('../components/tooltip/scripts/tooltip');
require('../components/mouseover-arrow/scripts/mouseover-arrow');
require('../components/scroll-tracking/scripts/scroll-tracking');
require('../components/login-prompt-initiator/scripts/login-prompt-initiator');
require('../components/bursary-form/scripts/bursary-form');
require('../components/comments-count/scripts/comments-count');
require('../components/ir-trigger/scripts/ir-trigger');
require('../components/edu-alert/scripts/edu-alert');
require('../components/edu-disclaimer/scripts/edu-disclaimer');
require('../components/approach-pointer/scripts/approach-pointer');
require('../components/edu-section-updater/scripts/edu-section-updater');
require('../components/edu-sitenavigation/scripts/edu-sitenavigation');
require('../components/edu-carousel/scripts/_edu-carousel');
require('../components/responsive-background/scripts/_responsive-background');
require('../components/edu-tabs/scripts/_edu-tabs');
require('../components/edu-search-filters/scripts/_edu-filters');
require('../components/edu-logout/scripts/_edu-logout');
require('../components/edu-send-filters/scripts/_edu-send-filters');
require('../components/edu-find-learning-results/scripts/edu-find-learning');
require('../components/edu-articles/scripts/edu-articles');
require('../components/edu-course-page/scripts/edu-course-page');

Snappy.init();



// WEBPACK FOOTER //
// ./scripts/eduhub-index.js